module.exports = __webpack_public_path__ + "static/media/Sound.04061272.webp";